import * as actionTypes from '../Register_action.types';
import * as api from '../register_api_services/ReturnsForms.api';

export const getReturnsFormsRequest = (unit_id) => ({
  type: actionTypes.GET_RETURNSNEW_FORMS_REQUEST,
  payload: unit_id,
});

export const getReturnsFormsSuccess = (rows) => ({
  type: actionTypes.GET_RETURNSNEW_FORMS_SUCCESS,
  payload: rows,
});

export const getReturnsFormsFailure = (error) => ({
  type: actionTypes.GET_RETURNSNEW_FORMS_FAILURE,
  payload: error,
});

export const getReturnsForms = (unit_id) => {
  return async (dispatch) => {
    dispatch(getReturnsFormsRequest(unit_id));
    try {
      const data = await api.fetchReturnsForms(unit_id);
      dispatch(getReturnsFormsSuccess(data));
      return { success: true, data };
    } catch (error) {
      dispatch(getReturnsFormsFailure(error));
      return { success: false, message: error };
    }
  };
};

/* -------- Returns (same module as forms) -------- */
export const getReturnsFormsnewRequest = () => ({
  type: actionTypes.GET_RETURNSNEW_FORMS_REQUEST,
});
export const getReturnsFormsnewSuccess = (rows) => ({
  type: actionTypes.GET_RETURNSNEW_FORMS_SUCCESS,
  payload: rows,
});
export const getReturnsFormsnewFailure = (error) => ({
  type: actionTypes.GET_RETURNSNEW_FORMS_FAILURE,
  payload: error,
});
export const getReturnsFormsnew = (unit_id) => {
  return async (dispatch) => {
    dispatch(getReturnsFormsnewRequest());
    try {
      const data = await api.fetchReturnsForms(unit_id);
      dispatch(getReturnsFormsnewSuccess(Array.isArray(data) ? data : []));
      return { success: true, data };
    } catch (error) {
      dispatch(getReturnsFormsnewFailure(error));
      return { success: false, message: error };
    }
  };
};

export const getReturnFormRequest = () => ({
  type: actionTypes.GET_RETURN_FORM_REQUEST,
});
export const getReturnFormSuccess = (row) => ({
  type: actionTypes.GET_RETURN_FORM_SUCCESS,
  payload: row,
});
export const getReturnFormFailure = (error) => ({
  type: actionTypes.GET_RETURN_FORM_FAILURE,
  payload: error,
});
export const getReturnForm = (id) => {
  return async (dispatch) => {
    dispatch(getReturnFormRequest());
    try {
      const data = await api.fetchReturnFormById(id);
      dispatch(getReturnFormSuccess(data));
      return { success: true, data };
    } catch (error) {
      dispatch(getReturnFormFailure(error));
      return { success: false, message: error };
    }
  };
};

export const createReturnsFormRequest = () => ({
  type: actionTypes.CREATE_RETURNS_FORM_REQUEST,
});
export const createReturnsFormSuccess = (row) => ({
  type: actionTypes.CREATE_RETURNS_FORM_SUCCESS,
  payload: row,
});
export const createReturnsFormFailure = (error) => ({
  type: actionTypes.CREATE_RETURNS_FORM_FAILURE,
  payload: error,
});
export const createReturnsForm = (payload) => {
  return async (dispatch) => {
    dispatch(createReturnsFormRequest());
    try {
      const data = await api.createReturnsFormApi(payload);
      dispatch(createReturnsFormSuccess(data));
      return { success: true, data };
    } catch (error) {
      dispatch(createReturnsFormFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateReturnsFormRequest = () => ({
  type: actionTypes.UPDATE_RETURNS_FORM_REQUEST,
});
export const updateReturnsFormSuccess = (msg) => ({
  type: actionTypes.UPDATE_RETURNS_FORM_SUCCESS,
  payload: msg,
});
export const updateReturnsFormFailure = (error) => ({
  type: actionTypes.UPDATE_RETURNS_FORM_FAILURE,
  payload: error,
});
export const updateReturnsForm = (id, payload) => {
  return async (dispatch) => {
    dispatch(updateReturnsFormRequest());
    try {
      const data = await api.updateReturnsFormApi(id, payload);
      dispatch(updateReturnsFormSuccess(data));
      return { success: true, data };
    } catch (error) {
      dispatch(updateReturnsFormFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deleteReturnsFormRequest = () => ({
  type: actionTypes.DELETE_RETURNS_FORM_REQUEST,
});
export const deleteReturnsFormSuccess = (msg) => ({
  type: actionTypes.DELETE_RETURNS_FORM_SUCCESS,
  payload: msg,
});
export const deleteReturnsFormFailure = (error) => ({
  type: actionTypes.DELETE_RETURNS_FORM_FAILURE,
  payload: error,
});
export const deleteReturnsForm = (id) => {
  return async (dispatch) => {
    dispatch(deleteReturnsFormRequest());
    try {
      const data = await api.deleteReturnsFormApi(id);
      dispatch(deleteReturnsFormSuccess(data));
      return { success: true, data };
    } catch (error) {
      dispatch(deleteReturnsFormFailure(error));
      return { success: false, message: error };
    }
  };
};

export const CreateGenerateFormData = (formtDataInput) => ({
  type: actionTypes.CREATE_GENERATENEW_FORM_REQUEST,
  payload: formtDataInput,
});

export const CreateGenerateFormDataSuccess = (user) => ({
  type: actionTypes.CREATE_GENERATENEW_FORM_SUCCESS,
  payload: user,
});

export const CreateGenerateFormDataFailure = (error) => ({
  type: actionTypes.CREATE_GENERATENEW_FORM_FAILURE,
  payload: error,
});



export const CreateGenerateFormInput = (formtDataInput, options = {}) => {
  return async (dispatch) => {
    dispatch(CreateGenerateFormDataSuccess(formtDataInput));
    try {
      const response = await api.CreateGenerateReturnForm(formtDataInput, options);
      if (response.data == null) {
        dispatch(CreateGenerateFormDataFailure(response.error));
        return { success: false, message: response.error, payload: response.errorPayload || null };
      }
      if (response.status === 200) {
        dispatch(CreateGenerateFormDataSuccess(response.data.user));
        return {
          success: true,
          message: response,
          data: response,
          generatedFormId: response.generatedFormId || null,
        };
      } else {
        dispatch(CreateGenerateFormDataFailure(response.message || ' input failed'));
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(CreateGenerateFormDataFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getReturnSelectedYearRequest = () => ({
  type: actionTypes.GET_RETURN_SELECTED_YEAR_REQUEST,
});

export const getReturnSelectedYearSuccess = (payload) => ({
  type: actionTypes.GET_RETURN_SELECTED_YEAR_SUCCESS,
  payload,
});

export const getReturnSelectedYearFailure = (error) => ({
  type: actionTypes.GET_RETURN_SELECTED_YEAR_FAILURE,
  payload: error,
});

export const RETURN_MODES = {
  GENERATE: "Generate Return",
  OVERRIDE: "Override Return",
  ACK: "Acknowledgement upload",
};

export const getReturnSelectedYear = (client_id, unit_id, form_name) => {
  return async (dispatch) => {
    dispatch(getReturnSelectedYearRequest());
    try {
      const data = await api.fetchReturnsFormsYear(client_id, unit_id, form_name);
      dispatch(getReturnSelectedYearSuccess(data));
      return { success: true, data };
    } catch (error) {
      dispatch(getReturnSelectedYearFailure(error));
      return { success: false, message: error };
    }
  };
};

export const uploadReturnFile = (payload) => {
  return async () => {
    try {
      const data = await api.uploadReturnGeneratedFile(payload);
      const ok = data?.success === true;
      const message =
        (typeof data?.message === 'object' && data.message?.message) ||
        (typeof data?.message === 'string' && data.message) ||
        'File uploaded successfully.';
      const generatedFormId =
        (typeof data?.message === 'object' && data.message?.generated_form_id) ||
        null;
      return { success: ok, message, data, generatedFormId };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};


